import path from "path";
import Account from "../pages/Account/Account";
import Credits from "../pages/Credits/Credits";
import Exchanger from "../pages/Exchanger/Exchanger";
import Pools from "../pages/Pools/Pools";
import Presale from "../pages/Presale/Presale";
import PresaleExcahnge from "../pages/PresaleExcahnge/PresaleExcahnge";
import PresaleExchangeDone from "../pages/PresaleExcahnge/PresaleExchangeDone/PresaleExchangeDone";
import Profile from "../pages/AccountWorkspace/AccountWorkspace";
import PurchaseExchange from "../pages/PurchaseExchange/PurchaseExchange";
import {
  ACCOUNT_RESET_PASSWORD_ROUTE,
  ACCOUNT_ROUTE,
  CREDITS_ROUTE,
  EXCHANGER_ROUTE,
  POOLS_ROUTE,
  PRESALE_EXCHANGE_DONE_ROUTE,
  PRESALE_EXCHANGE_ROUTE,
  PRESALE_PURCHASE_ROUTE,
  PRESALE_ROUTE,
  PROFILE_ROUTE,
  REGISTER_ROUTE_WITH_REF,
} from "../utils/consts";
import ResetPasswordForm from "../pages/Account/ResetPasswordForm/ResetPasswordForm";

export const authRoutes = [
  {
    path: PROFILE_ROUTE,
    Component: Profile,
  },
  {
    path: PRESALE_EXCHANGE_ROUTE,
    Component: PresaleExcahnge,
  },
  {
    path: PRESALE_EXCHANGE_DONE_ROUTE,
    Component: PresaleExchangeDone,
  },
  {
    path: PRESALE_PURCHASE_ROUTE,
    Component: PurchaseExchange,
  },
];

export const publicRoutes = [
  {
    path: POOLS_ROUTE,
    Component: Pools,
  },
  {
    path: EXCHANGER_ROUTE,
    Component: Exchanger,
  },
  {
    path: PRESALE_ROUTE,
    Component: Presale,
  },
  {
    path: ACCOUNT_ROUTE,
    Component: Account,
  },
  {
    path: REGISTER_ROUTE_WITH_REF,
    Component: Account,
  },
    {
    path: CREDITS_ROUTE,
    Component: Credits,
  },
  {
    path: ACCOUNT_RESET_PASSWORD_ROUTE,
    Component: ResetPasswordForm,
  }
];
